import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Users, Award, BookOpen, Target, Shield, Globe } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Target,
      title: 'Nuestra Misión',
      description: 'Formar profesionales de seguridad con los más altos estándares internacionales, proporcionando conocimientos actualizados y habilidades prácticas.'
    },
    {
      icon: Shield,
      title: 'Excelencia en Seguridad',
      description: 'Programas especializados diseñados por expertos internacionales en seguridad física, protección ejecutiva y ciberseguridad.'
    },
    {
      icon: Globe,
      title: 'Alcance Internacional',
      description: 'Certificaciones reconocidas globalmente que abren puertas a oportunidades profesionales en todo el mundo.'
    },
    {
      icon: BookOpen,
      title: 'Metodología Práctica',
      description: 'Aprendizaje basado en casos reales, simulaciones y ejercicios prácticos supervisados por instructores certificados.'
    }
  ];

  return (
    <div className="py-12 bg-secondary min-h-screen" data-testid="about-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <img 
            src="/iaasp_logo.png" 
            alt="IAASP Logo" 
            className="w-24 h-24 mx-auto mb-6"
          />
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4">
            Sobre IAASP Academy
          </h1>
          <p className="text-lg text-[#c5a465] font-medium mb-4">
            International Alliance of Advanced Security Programs
          </p>
          <p className="text-base text-muted-foreground max-w-3xl mx-auto">
            Somos la alianza internacional líder en programas de seguridad avanzada. Nuestra academia ofrece formación profesional de excelencia con certificaciones reconocidas globalmente.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {values.map((value, idx) => (
            <Card key={idx} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center mb-4">
                  <value.icon className="w-6 h-6 text-accent" />
                </div>
                <CardTitle className="text-xl">{value.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{value.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-to-br from-[#0b1220] via-[#1a2744] to-[#0b1220] text-white rounded-xl p-12 text-center">
          <h2 className="text-3xl font-heading font-bold mb-8">Nuestro Impacto Global</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="text-4xl font-bold text-[#c5a465] mb-2">2500+</div>
              <div className="text-white/80">Profesionales Certificados</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#c5a465] mb-2">25+</div>
              <div className="text-white/80">Programas Especializados</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#c5a465] mb-2">15+</div>
              <div className="text-white/80">Países con Presencia</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#c5a465] mb-2">98%</div>
              <div className="text-white/80">Satisfacción Estudiantil</div>
            </div>
          </div>
        </div>

        {/* Team Section */}
        <div className="mt-16 text-center">
          <h2 className="text-3xl font-heading font-bold text-primary mb-6">
            Instructores de Élite
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto mb-8">
            Nuestro equipo está compuesto por profesionales con experiencia operativa en fuerzas de seguridad, agencias de protección ejecutiva y empresas de seguridad corporativa a nivel mundial.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
